"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Shimmer = _interopRequireDefault(require("../Shimmer"));

var _ShimmerCreditCard = _interopRequireDefault(require("./ShimmerCreditCard.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ShimmerWrapper = _styledComponents.default.div.withConfig({
  displayName: "ShimmerCreditCard__ShimmerWrapper",
  componentId: "sc-6l9s8w-0"
})([""]);

var ShimmerOneCol = _styledComponents.default.div.withConfig({
  displayName: "ShimmerCreditCard__ShimmerOneCol",
  componentId: "sc-6l9s8w-1"
})(["padding:3px 0;"]);

var ShimmerTwoCol = _styledComponents.default.div.withConfig({
  displayName: "ShimmerCreditCard__ShimmerTwoCol",
  componentId: "sc-6l9s8w-2"
})(["display:flex;justify-content:space-between;padding:5px 0;"]);

var ShimmerCreditCard = function ShimmerCreditCard(props) {
  var accessible = props.accessible,
      theme = props.theme,
      customProperties = props.customProperties;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var shimmerProps = {
    accessible: accessible,
    theme: theme,
    customProperties: customProperties
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(ShimmerWrapper, null, /*#__PURE__*/_react.default.createElement(ShimmerOneCol, null, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({}, shimmerProps, {
      width: "100%"
    }))), /*#__PURE__*/_react.default.createElement(ShimmerTwoCol, null, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({}, shimmerProps, {
      width: "50%"
    })), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({}, shimmerProps, {
      width: "45%"
    }))), /*#__PURE__*/_react.default.createElement(ShimmerOneCol, null, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({}, shimmerProps, {
      width: "100%"
    }))), /*#__PURE__*/_react.default.createElement(ShimmerOneCol, null, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({}, shimmerProps, {
      width: "10%"
    }))));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

ShimmerCreditCard.propTypes = _ShimmerCreditCard.default.PropTypes;
ShimmerCreditCard.defaultProps = _ShimmerCreditCard.default.DefaultProps;
var _default = ShimmerCreditCard;
exports.default = _default;